export const CHECKOUT_CONTAINER_ID = 'checkout-app';
export const CHECKOUT_CONTAINER = document.getElementById(
  CHECKOUT_CONTAINER_ID,
);
export const CHECKOUT_ID = window.EbizioEventManager.checkoutId;
export const CART_ID = CHECKOUT_ID;
